import type { Price } from '@tsTypes/api/Price';
import hasFreeDelivery from '@utils/hasFreeDelivery';

type PriceParts = Partial<Exclude<Price['priceParts'], unknown[]>>;

type PriceWithDeliveryPart = {
  priceParts?: Price['priceParts'];
  discountParts?: Price['discountParts'];
};

export const getDeliveryCostBeforeDiscount = (
  price?: PriceWithDeliveryPart | null
): number => {
  const priceParts = price?.priceParts as PriceParts | undefined;

  return priceParts?.DELIVERY ?? 0;
};

const getDeliveryCost = (price?: PriceWithDeliveryPart | null): number =>
  hasFreeDelivery(price) ? 0 : getDeliveryCostBeforeDiscount(price);

export default getDeliveryCost;
